<template>
  <div class="vsd420">
    <Head></Head>
    <div style="width: 99%;margin:0 10px; height: calc(100vh - 6.225rem); position: absolute" class="flex_1">
      <DashboardLeft :breakdown_point="breakdown_point" :equip_data="equip_data" :measurements_list="measurementsDatas"></DashboardLeft>
       <!-- 设备正常运行 -->
       <PanelData :currentState="groupCurrentState" :equip_data="equip_data"></PanelData>
      <ModelPaperMaking  v-if="equip_data.id&&isPaperMaking" :equip_data='equip_data'  @changeBreak="changeBreak" @onlineChange="onlineChange" :breakdown_point="breakdown_point" :onlineShop="onlineShop"></ModelPaperMaking>
      <Model  v-else :equip_data='equip_data'  @changeBreak="changeBreak" @onlineChange="onlineChange" :breakdown_point="breakdown_point" :onlineShop="onlineShop"></Model>
      <DashboardRight v-if="false" :equip_data="equip_data" :topIndex="topIndex" :measurements_list="measurements_list"></DashboardRight>

      <transition name="shop-transform" mode="out-in">
        <OnlineShop v-if="onlineShop" @onlineChange="onlineChange" :onlineShop="onlineShop"></OnlineShop>
      </transition>
      <Control
          :onlineShop="onlineShop"
          :choose-controls="chooseControls"
          :equip_data="equip_data"
      ></Control>
    </div>
  </div>

</template>
<script>
import Model from "@/components/devices/VSD420-Fault/Model3D"
import ModelPaperMaking from "@/components/devices/VSD420-Fault/Model3DPaperMaking"
import DashboardLeft from "@/components/devices/VSD420-Fault/dashboard_left/DashboardLeft"
import DashboardRight from "@/components/devices/VSD420-Fault/dashboard_right/DashboardRight"
import OnlineShop from "@/components/devices/VSD420-OnlineShop/Index"
import Control from "@/components/devices/Control"
import PanelData from '@/components/devices/VSD420-OverAll/PanelData';
import _ from "lodash";
import { SOCKET_SVC_HOST } from "@/config/common.js";
let list = [
  "http://52.83.66.102:5011/public/VSD420/干泵.glb",
  "http://52.83.66.102:5011/public/VSD420/干泵-罗茨泵.glb",
  "http://52.83.66.102:5011/public/VSD420/干泵-罗茨泵电机.glb",
  "http://52.83.66.102:5011/public/VSD420/干泵-罗杆泵.glb",
  "http://52.83.66.102:5011/public/VSD420/干泵-罗杆泵电机.glb",
  "http://52.83.66.102:5011/public/VSD420/fault/螺杆泵闪动球.glb",
  "http://52.83.66.102:5011/public/VSD420/fault/螺杆泵状态球.glb",
  "http://52.83.66.102:5011/public/VSD420/fault/螺杆泵上状态球.glb"
];

import { getInstancesDetailId } from "@/service/index";
import { reactive } from "vue";
import { useRoute } from "vue-router"
// import _ from 'lodash';
export default {
  setup() {
    const route = useRoute()
    const equip_data = reactive({});
    const measurements_list = reactive([]);
    const measurementsDatas = reactive([]);

    const data = localStorage.getItem('equip_id')
    if(!route.query.equip_id){
      return
    }
    getInstancesDetailId({id:route.query.equip_id||data}).then((res) => {
      if (res && res.payload) {
        Object.assign(equip_data, res.payload)
        /* 测点数组数据 */ 
        if(res.payload.attributes){
          Object.assign(measurements_list, res.payload.attributes.measurements) 
          Object.assign(measurementsDatas, res.payload.attributes.measurements) 
        }

      }
    });
    return {
      equip_data,
      measurements_list,
      measurementsDatas
    };
  },
  name: "vsd420-F",
  data() {
    return {
      breakdown_point:'',
      // chooseControls: 3, 
      onlineShop: false,
      modelList: list,
      markeData: [],
      timer: null,
      isPanelData:true,/* 设备正常运行状态 */ 
      currentState: "stop",
      topIndex:[],  /* 置顶展示两个测点信息 */ 
    };
  },
  computed: {
    chooseControls(){//为机组时显示
      return this.equip_data.product_type == 2?2:3;
    },
    //关于机组状态
    currentObj(){
      return this.$store.state.equipManagement.current_obj;
    },
    groupCurrentState(){ 
      let reslut  = "stop";
      let obj = { "stop":0,"normal":0 }
      if(this.equip_data.product_type == 2){ //机组
        for(let key in this.currentObj){
          for(let measu in this.currentObj[key]){
            if (this.currentObj[key][measu]>2) {
              obj["normal"] += 1
            }
          }
        }
        if (obj["normal"]) {
          reslut = "normal"
        }
      }else{ //相关单体设备
        if( this.currentObj[this.equip_data.id]){
          for(let key in this.currentObj[this.equip_data.id]){
            if (this.currentObj[this.equip_data.id][key]>2) {
              reslut = "normal"
            }
          }
        }
      }
      return reslut;
    }, 
    //造纸厂展示内容
    isPaperMaking(){
      return this.$store.state.equipManagement.isDemonstrationPaperMaking;
    }
  },
  watch: {
    "$i18n.locale": {
      handler() {},
      deep: true
    },
  },
  created() {},
  mounted() {
    this.topIndex = JSON.parse(this.$route.query.top_index)
    if(this.$route.query.type==='online'||this.$route.query.type==='product-online'){
      this.onlineShop=true
    }
    if(this.$route.query.index==1){
      this.breakdown_point='电机超功率'
    }else if(this.$route.query.index==2){
      this.breakdown_point='卡泵低风险预警'
    }else{
      this.breakdown_point='电机绕阻温度高'
    }
    // window.addEventListener("resize", () => {
    //   window.location.reload();
    // });
    /* 实时获取推送测点数据 */ 
    this.initWebSocket()
  },
  beforeUnmount() {
    clearInterval(this.timer2)
    // window.removeEventListener("resize", () => {
      // window.location.reload();
    // });
    if (this.timer) {
      this.timer = null;
    }
  },
  methods: {
    //** WebSocket 实时获取实例详情测点数据 */
    initWebSocket() {
      const interval = setInterval(() => {
        if (this.retryCount > 10) {
          clearInterval(interval)
          this.retryCount = 0
          return
        }
        const stompClient = this.$websocket.getters.stompClient()
        if (stompClient != null && stompClient.connected) {
          clearInterval(interval)
          stompClient.subscribe("/topic/stream", msg => {
            if (msg && msg.body) {
              let websocketdata = Array.isArray(JSON.parse(msg.body)) ? JSON.parse(msg.body) : [JSON.parse(msg.body)];
              /* 避免其他页面触发 */ 
                if (this.$route.path == "/VSD420-Fault") {   
                  /*  获取推送数据,处理 */ 
                  this.getWebsocket(websocketdata)
                }
            }
          })
        } else {
          if (!localStorage.getItem("accessToken")) return
          const _url = SOCKET_SVC_HOST + "/messaging/stomp?access_token=" + localStorage.getItem("accessToken");
          this.$websocket.dispatch('WEBSOCKET_INIT', _url)
        }
        this.retryCount++
      }, 1000)
    }, 
    // 获取推送数据,处理
    getWebsocket(socdata) {
      let current_obj = _.cloneDeep(this.currentObj)
      if ( socdata && socdata.length ) {
        socdata.map((soc) => {
          /* 匹配推送的对应设备的id */ 
          if((soc.shadowId == this.equip_data.id)&&soc.report.length){

            /* 是否有IOT数据，是否展示升级  按钮 HEALTH 0, WARNING 1, ERROR 2 */
            // this.isShowEcharts =  true
            // if(soc.report.some(item=>item.stat == 1)||soc.report.some(item=>item.stat == 2)){
            //   this.isPanelData = false //存在异常,不展示该图标
            // }else if(soc.report.every(item=>item.stat == 0)){
            //   this.isPanelData = true //未存在异常,展示该图标
            // }
            for(let item of soc.report){
              /* 复制对应测点值 */ 
              let _index = this.measurements_list.findIndex(i => i.key === item.id)
              if(_index >-1){
                this.measurements_list[_index] = {
                  ...this.measurements_list[_index], 
                  v:item.v, 
                  stat:item.stat
                }
              }
              /* 设备的开停机状态 */ 
              if(current_obj[soc.shadowId]){
                for(let key in current_obj[soc.shadowId]){
                  if (key == item.id) {
                    current_obj[soc.shadowId][key] = item.v
                  }
                }
              }
            }

          }
        });
      }
      this.$store.commit( "equipManagement/set_current_obj", current_obj); 
    },
    onlineChange(flag){
      this.onlineShop=flag
    },
    changeBreak(val){
      this.breakdown_point=val
    },
    randoms(min, max) {
      return parseFloat(Math.random() * (max - min) + min).toFixed(1);
    }
  },
  components: {
    Model,
    ModelPaperMaking,
    DashboardLeft,
    DashboardRight,
    OnlineShop,
    Control,
    PanelData
  }
};
</script>

<style lang="scss">
@import url("../../../assets/scss/common.scss");

.vsd420 {
  width: 100%;
  height: 100vh;
  position: relative;
  font-size: 16px;
  background-image:radial-gradient(circle,#2f5278,#0f2239,#071729);
  color: #fff;
}
</style>
